import React from "react";

import PageContainer from "./components/PageContainer";
import PageContent from "./components/PageContent";
import Sidebar from "./components/sidebar/Sidebar";

const ClientLayout = () => {
  return (
    <PageContainer>
      <Sidebar />
      <PageContent />
    </PageContainer>
  );
};

export default ClientLayout;
